import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './voucherForm';
import DateFormat from '../common/dateFormat/DateFormat';
import BoxButtonHeader from '../common/button/boxButtonHeader';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import Select from '../common/form/select';
import FormatUtils from '../common/formatUtils/FormatUtils';
import ReactExport from 'react-export-excel-fixed-xlsx';
import ReactSelect from 'react-select';

import {
	setModoTela, initForm, salvar, excluir, getLista,
	setFiltro
} from './voucherActions';
import consts from '../consts';

class Voucher extends Component {

	state = {
		linhaSelecionada: null
	}

	componentWillMount() {
		this.props.getLista();


	}

	render() {
		return (
			<div>

				{this.props.aguardando ? (
					<div class='modal fade show' id='modal-overlay' style={{ display: 'block', paddingRight: 15 }} aria-modal='true' role='dialog'>
						<div class='modal-dialog'>
							<div class='overlay'>
								<i class='fas fa-4x fa-spinner fa-spin' style={{ marginLeft: '50%', marginRight: '50%' }}></i>
							</div>
						</div>
					</div>
				) : null}

				<Content>
					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
				</Content>
			</div>
		)
	}

	lista() {

		const ExcelFile = ReactExport.ExcelFile;
		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		let lista = this.props.lista.filter(item => {
			return !this.state.pesquisar
				|| (`
					${item.idade}
					${item.whatsapp}
					${item.profissao}
					${item.cidade}
					${item.estado_civil}
					${item.quem_viaja}
					${item.quanto_viaja}
					${item.plataforma}
					${item.media_gasto}
					${item.destino}
					${item.lgpd ? 'Aceito' : ''}
				`).toUpperCase().includes(this.state.pesquisar.toUpperCase());
		});

		return (
			<ContentCard>
				<BoxButtonHeader>
					<Row>
						<Grid cols='6 4 3 2'>
							<ExcelFile
								filename={'Vouchers'}
								element={
									<Button
										text='Exportar'
										type={'primary'}
										icon={'fa fa-download'}
										style={{ width: '100%' }} />
								}>
								<ExcelSheet data={lista.map(item => ({
									...item,
									lgpd: item.lgpd ? 'Aceito' : ''
								}))} name='Vouchers'>
									<ExcelColumn label='Nome' value='nome'/>
									<ExcelColumn label='Idade' value='idade'/>
									<ExcelColumn label='WhatsApp' value='whatsapp'/>
									<ExcelColumn label='Profissao' value='profissao'/>
									<ExcelColumn label='Cidade' value='cidade'/>
									<ExcelColumn label='Estado Civil' value='estado_civil'/>
									<ExcelColumn label='Quem Viaja' value='quem_viaja'/>
									<ExcelColumn label='Quanto Viaja' value='quanto_viaja'/>
									<ExcelColumn label='Plataforma Utilizada' value='plataforma'/>
									<ExcelColumn label='Média de Gasto' value='media_gasto'/>
									<ExcelColumn label='Destino' value='destino'/>
									<ExcelColumn label='LGPD' value='lgpd'/>
									<ExcelColumn label='Status' value='status'/>
								</ExcelSheet>
							</ExcelFile>
						</Grid>
					</Row>
				</BoxButtonHeader>
				<Row>
					<LabelAndInputMask
						label='Data Inicial'
						placeholder='Informe a Data Inicial'
						mask={'99/99/9999'}
						cols='12 4 3'
						value={this.props.filtro.dataInicial}
						onChange={data => {
							this.props.setFiltro({
								...this.props.filtro,
								dataInicial: data.target.value
							});
						}} />

					<LabelAndInputMask
						label='Data Final'
						placeholder='Informe a Data Final'
						mask={'99/99/9999'}
						cols='12 4 3'
						value={this.props.filtro.dataFinal}
						onChange={data => {
							this.props.setFiltro({
								...this.props.filtro,
								dataFinal: data.target.value
							});
						}} />

					<Select
						name='status'
						options={this.props.listaStatus}
						label='Status'
						cols='12 4 3'
						placeholder='Selecione o Status'
						value={this.props.filtro.status}
						onChange={value => {
							this.props.setFiltro({
								...this.props.filtro,
								status: value
							});
						}} />
				
					<Grid cols='6 6 2 1'>
						<Button
							style={{ marginTop: 25 }}
							text='Atualizar'
							type={'primary'}
							icon={''}
							event={() => {
								this.props.getLista();
							}} />
					</Grid>

					<Grid cols='12 12 12 12'>

						<input className='form-control'
							placeholder='Pesquisar'
							type='text'
							value={this.state.pesquisar}
							onChange={e => {
								this.setState({ ...this.state, pesquisar: e.target.value });
							}} />
					</Grid>
				</Row>
				<ContentCardBody>
					<Table responsive>
						<THead>
							<Tr>
								<Th alignLeft>Nome</Th>
								<Th alignCenter>Idade</Th>
								<Th alignCenter>WhatsApp</Th>
								<Th alignCenter>Profissao</Th>
								<Th alignCenter>Cidade</Th>
								<Th alignCenter>Estado Civil</Th>
								<Th alignCenter>Quem Viaja</Th>
								<Th alignCenter>Quanto Viaja</Th>
								<Th alignCenter>Plataforma Utilizada</Th>
								<Th alignCenter>Média de Gasto</Th>
								<Th alignCenter>Destino</Th>
								<Th alignCenter>LGPD</Th>
								<Th alignCenter>Foto</Th>
								<Th alignCenter>Status</Th>
							</Tr>
						</THead>
						<TBody>
							{lista.map(item => (
								<Tr key={item.id}>
									<Td>{item.nome}</Td>
									<Td alignCenter>{item.idade}</Td>
									<Td alignCenter>{item.whatsapp}</Td>
									<Td alignCenter>{item.profissao}</Td>
									<Td alignCenter>{item.cidade}</Td>
									<Td alignCenter>{item.estado_civil}</Td>
									<Td alignCenter>{item.quem_viaja}</Td>
									<Td alignCenter>{item.quanto_viaja}</Td>
									<Td alignCenter>{item.plataforma}</Td>
									<Td alignCenter>{item.media_gasto}</Td>
									<Td alignCenter>{item.destino}</Td>
									<Td alignCenter>{item.lgpd ? 'Aceito' : ''}</Td>
									<Td alignCenter>
										{item.foto &&
										<ButtonTable
											type={'primary'}
											icon={'fa fa-image'}
											event={() => {
												
												const url = `${consts.URL}${item.foto}`;

												const nomeArquivo = item.foto.split('/').pop() || 'foto.png';

												this.baixarFoto(url, nomeArquivo);
												
											}} />}
									</Td>
									<Td>
										<select
											value={item.status || ''}
											onChange={(e) => {
												const value = e.target.value;

												if (value) {
													const selected = this.props.listaStatus.find(
														opt => String(opt.id) === value
													);

													this.props.salvar({
														...item,
														status: value,
														label: selected ? selected.valor : ''
													});
												}
											}}
										>
											{this.props.listaStatus.map(opt => (
												<option
													key={opt.id}
													value={opt.id}
												>
													{opt.valor}
												</option>
											))}
										</select>
									</Td>
								</Tr>
							))}

						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}

	async baixarFoto(url, nomeArquivo) {

		try {

			const resposta = await fetch(url);

			if (!resposta.ok) {
				throw new Error('Erro ao baixar a imagem');
			}

			const blob = await resposta.blob();
			const urlTemporaria = window.URL.createObjectURL(blob);

			const link = document.createElement('a');

			link.href = urlTemporaria;
			link.download = nomeArquivo;

			document.body.appendChild(link);

			link.click();
			link.remove();

			window.URL.revokeObjectURL(urlTemporaria);

		} catch (erro) {

			console.error(erro);
			alert('Não foi possível baixar a imagem.');

		}

	}

}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioLogado: state.auth.usuarioLogado,
	modoTela: state.voucher.modoTela,
	lista: state.voucher.lista,
	aguardando: state.voucher.aguardando,
	filtro: state.voucher.filtro,
	listaStatus: state.voucher.listaStatus
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm, salvar, excluir, getLista,
	setFiltro
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Voucher);